module.exports = __webpack_public_path__ + "img/1.05024a2a.png";